import { useEffect, useMemo } from "react";

import { IApiCorbansResponse, useApiCorbans } from "@hooks/api/auth";

export type CorbanOption = IApiCorbansResponse["results"][0] & {
  name: string;
};

type UseOptionsProps = {
  skipFetch?: boolean;
};

export const useCorbansOptions = ({ skipFetch }: UseOptionsProps = {}) => {
  const [fetchCorbans, { data, ...state }] = useApiCorbans();

  const parsedCorbans = useMemo(() => {
    return data?.results.map((corban) => ({
      ...corban,
      name: corban.fantasy_name || corban.corban_name,
    }));
  }, [data?.results]);

  useEffect(() => {
    const fetch = async () => {
      try {
        await fetchCorbans();
      } catch {
        // do nothing
      }
    };

    if (!skipFetch) {
      void fetch();
    }
  }, [skipFetch, fetchCorbans]);

  return {
    options: parsedCorbans ?? [],
    ...state,
  };
};
